<template>
    <div class="modal-backdrop" v-if="renderComponent">
      <div class="modal">
        <button type="button"
                class="btn-close"
                @click="close"> x
        </button>
        <div class="content">
            <header class="modal-header">
                <slot name="header">
                    <h2>{{translate('discounts_edit_header')}}</h2>

                </slot>
            </header>
            <div class="modal-body">
                <template v-if="discounts.length>0">
                    <div class="column rows-container">
                        <div class="row header">
                            <span>{{translate('discounts_title')}}</span>
                            <span>{{translate('discounts_value')}}</span>
                            <span/>
                        </div>
                        <div class="row" v-for="(discount, key) in discounts" :key="key">
                            <div class="title">
                              {{translateOption(discount.id, discount.title)}}
                            </div>
                            <div class="value" @click="discount.edit = true">
                                <div class="question-mark" v-if="translateHelp(discount.id, discount.title)" @mouseover="tooltip = discount.id" @mouseout="tooltip = -1">
                                    ?
                                    <div v-if="tooltip == discount.id" class="tooltip">{{ translateHelp(discount.id, discount.title) }}</div>
                                </div>
                                <span class="price" v-if="!discount.edit">{{discount.value}}</span>
                                <input type="text" @blur="discount.edit = false" v-else class="edit-input"
                                       v-model="discount.value" @change="validateEditedValue(discount)">
                                <span class="currency">%</span></div>
                            <div class="actions">
                                <span @click="removeDiscount(key)">{{translate("discounts_delete")}}</span>
                            </div>
                            

                          <ul v-if="discount.non_standard_discounts == 1">
                            <li v-if="discount.options" v-for="(option, optKey) in discount.options" :key="optKey">
                              <div class="flex">
                                <p v-if="optionedit != optKey" @click="optionedit = optKey">
                                  {{option}}
                                </p>
                                <input type="text" @blur="optionedit = -1" v-else class="edit-input"
                                       v-model="discount.options[optKey]">
                                <span @click="removeDiscountOption(key, optKey)">{{translate("discounts_delete")}}</span>
                              </div>
                            </li>

                            <div class="add-custom-options-box">
                              <template v-if="discount.editMode && freshOptions.hasOwnProperty(key)">
                                <input type="text" class="edit-input" v-model="freshOptions[key]">
                                <div class="flex">
                                    <div @click="cancelAddingCustomOption(key)" class="add-custom-option-button cancel">
                                      <span>{{translate('cancel')}}</span>
                                    </div>
                                    <div @click="addDiscountCustomOption(key)" class="add-custom-option-button">
                                      <span>{{translate('add')}}</span>
                                    </div>
                                  </div>
                              </template>
                              <template v-else>
                                <span class="add-custom-option"
                                  @click="addCustomOption(key)">+ {{translate('add_custom_option')}}</span>
                              </template>
                            </div>
                          </ul>
                        </div>
                    </div>
                </template>
                <div v-else>
                    <p>{{translate('discounts_no_added_yet')}}</p>
                </div>
                <div class="add-surcharge-box">
                    <template v-if="fresh.editMode">
                        <div class="column">
                            <div class="row header">
                                <span>{{translate('discounts_title')}}</span>
                                <span>{{translate('discounts_value')}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="edit-box">

                                    <div class="custom-select">
                                        <div class="selected_item" :class="{'warn': errors.fresh_title}">
                                            <input class="value input-value"
                                                   :class="{'selected': isOptionSelected}"
                                                   v-model="searchOptionInputValue"
                                                   :placeholder="searchOptionInputIsFocused ? '' : (isOptionSelected ? translateOption(fresh.id, fresh.title) : translate('search_option'))"
                                                   @focus="focusOnDiscountsOptions"
                                                   @focusout="focusOutDiscountsOptions"
                                                   @input="inputDiscountsOptions"
                                            />
                                            <span class="icon-bottom_arrow"></span>
                                        </div>
                                        <div class="items-container" v-if="filteredOptions.length > 0">
                                            <div class="item" @click="selectTitle(option)" v-for="option in filteredOptions">
                                                <span>{{option.language[currentLocale].value}}</span>
                                            </div>
                                        </div>
                                      <div v-else class="items-container no-item">
                                        <div class="item">
                                          <span>{{ translate('no_results') }}</span>
                                        </div>
                                      </div>
                                    </div>
                            </div>
                            <div class="edit-box">
                                <input type="text" class="edit-input" v-model="fresh.value">
                                <span class="currency">%</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="box">
                                <div @click="cancelDiscount" class="add-action-button cancel">
                                    <span>{{translate('cancel')}}</span>
                                </div>
                                <div @click="addDiscount" class="add-action-button">
                                    <span>{{translate('discounts_add_new')}}</span>
                                </div>
                            </div>

                        </div>
                    </template>
                    <template v-else>
                        <span class="add-process-btn"
                              @click="editNewAction">+ {{translate('discounts_add_new')}}</span>
                    </template>
                </div>
                <p class="surcharges-total">{{translate('discounts_total')}}: {{ getTotalDiscount }}%</p>
            </div>
            <footer class="modal-footer">
                <slot name="footer">
                    <div class="navi-btns">
                        <span @click="close" class="back-btn circle-btn">
                        </span>
                        <button @click="save" class="summary-btn">{{translate("discounts_approve")}}</button>
                    </div>
                </slot>
            </footer>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "modal",
        components: {},
        data() {
            return {
                tooltip: -1,
                optionedit: -1,
                lastDeleted: {},
                renderComponent: true,
                discounts: [],
                errors: {
                    fresh_title: false
                },
                currentLocale: 0,
                options: [],
                fresh: {
                    title: '',
                    value: '',
                    id: '',
                    non_standard_discounts: 0,
                    editMode: false,
                    is_image_visible: false,
                    image: null,
                },
              freshOptions: {
              },
              searchOptionInputIsFocused: false,
              searchOptionInputValue: '',
              searchOptionFilterValue: '',
            }
        },
        methods: {
          inputDiscountsOptions() {
              this.searchOptionFilterValue = this.searchOptionInputValue;
          },

          focusOutDiscountsOptions() {
            this.searchOptionInputIsFocused = false;
            this.searchOptionInputValue = '';
          },

          focusOnDiscountsOptions() {
            this.searchOptionInputValue = '';
            this.searchOptionFilterValue = '';
            this.searchOptionInputIsFocused = true;
          },

          forceRerender() {
            this.renderComponent = false;

            this.$nextTick(() => {
              this.renderComponent = true;
            });
          },
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            makeDiscount(string) {
                return parseFloat(string.replace(',', '.')).toFixed(0);
            },

            validateEditedValue(discount) {
                discount.value = this.makeDiscount(discount.value);
            },

            removeDiscount(key) {
                this.lastDeleted = this.discounts.splice(key, 1);
            },

            addCustomOption(key){
                this.freshOptions[key] = "";
                Vue.set(this.discounts[key], "editMode", true);
            },

            cancelAddingCustomOption(key){
              Vue.set(this.discounts[key], "editMode", false);

              if(this.freshOptions[key]){
                delete this.freshOptions[key];
              }
            },

            addDiscountCustomOption(key){
              if(this.freshOptions[key]){
                if(!this.discounts[key].hasOwnProperty("options") || !this.discounts[key].options){
                  this.discounts[key].options = [];
                }

                this.discounts[key].options.push(this.freshOptions[key]);
              }

              this.cancelAddingCustomOption(key);
            },

            removeDiscountOption(discountKey, optionKey){
              if(this.discounts[discountKey].hasOwnProperty("options") && this.discounts[discountKey].options.hasOwnProperty(optionKey))
                this.discounts[discountKey].options.splice(optionKey, 1);

              Vue.set(this.discounts[discountKey], "editMode", this.discounts[discountKey].editMode);
              this.forceRerender();
            },

            editNewAction() {
                this.fresh.id = null;
                this.fresh.title = '';
                this.fresh.value = '';
                this.fresh.editMode = true;
                this.errors.fresh_title = false;
                this.fresh.image = null;
                this.fresh.is_image_visible = false;
            },

            validateFreshInput() {
                this.errors.fresh_title = false;

                if (this.fresh.title.length === 0) {
                    this.errors.fresh_title = true;
                    return false;
                }

                return true;
            },

            translateOption(id, code) {
              if(this.options){
                  let currentLang = this.getCurrentLocaleIndex(this.options);
                  let option = this.options.find(x => x.id.indexOf(id) !== -1);
                  if(option) {
                      let translation = option.language[currentLang].value;
                      if(translation) return translation;
                  }
              }
              return code;
            },

            translateHelp(id, code) {
              if(this.options){
                  let currentLang = this.getCurrentLocaleIndex(this.options);
                  let option = this.options.find(x => x.id.indexOf(id) !== -1);
                  if(option) {
                      let translation = option.language[currentLang].help;
                      if(translation) return translation;
                  }
              }
            },

            selectTitle(element) {
                this.fresh.title = element.code;
                this.fresh.id = element.id[0];
                this.fresh.non_standard_discounts = element.non_standard_discounts;
                this.fresh.image = element.image;
                this.fresh.is_image_visible = element.is_image_visible;
                if(element.default_discount && element.default_discount !== 0) {
                    this.fresh.value = this.makeDiscount(element.default_discount);
                }
            },

            addDiscount() {
                if (!this.validateFreshInput()) return;

                this.fresh.value = this.makeDiscount(this.fresh.value);
                this.discounts.push(
                    {
                        title: this.fresh.title,
                        value: this.fresh.value,
                        id: this.fresh.id,
                        non_standard_discounts: this.fresh.non_standard_discounts,
                        edit: false,
                        is_image_visible: this.fresh.is_image_visible,
                        image: this.fresh.image
                    }
                );
                this.fresh.editMode = false;
            },

            cancelDiscount() {
                this.fresh.editMode = false;
            },

            save() {
                if(this.$store.state.productCard.custom.summary && this.$store.state.productCard.custom.summary.discounts) {
                    if(!this.$store.state.productCard.custom.summary.discounts) this.$store.state.productCard.custom.summary.discounts = {};
                    let summary = this.$store.state.productCard.custom.summary.discounts;
                    let keys = Object.keys(summary);
                    for (let key of keys) {
                        if (key.includes('discount') && summary.hasOwnProperty(key) && typeof summary[key] === "object") delete summary[key];
                    }

                    for (let discount in this.discounts) {
                        if (!this.discounts.hasOwnProperty(discount)) break;
                        let object = this.discounts[discount];
                        let option = this.options.find(x => x.id.indexOf(object.id) !== -1);

                        let mappedDiscount = {
                            title: object.title,
                            value: object.value,
                            id: object.id,
                            non_standard_discounts: object.non_standard_discounts,
                            options: object.options,
                            discount: object.value,
                            is_image_visible: option.language[0].is_image_visible,
                            image: option.language[0].image,
                        };

                        let keyName = 'discount_' + discount;
                        Vue.set(summary, keyName, mappedDiscount);
                    }
                }
                this.close();
                this.$parent.$emit('updateDiscount');
            },

            close() {
                this.$emit('close');
            },

            getCurrentLocaleIndex(options) {
                if(options.length>0){
                    return options[0].language.findIndex(x => x.id_language === this.$store.state.activeLang.id);
                }
            }
        },

        mounted() {
            this.options = this.$store.state.offerDiscounts;

            this.currentLocale = this.getCurrentLocaleIndex(this.options);

            if(!this.$store.state.productCard.custom.summary.discounts) this.$store.state.productCard.custom.summary.discounts = {};
            let summary = this.$store.state.productCard.custom.summary.discounts;
            let keys = Object.keys(summary);
            let discounts = [];

            for (let key of keys) {
                if (key.includes('discount') && summary.hasOwnProperty(key)) {
                    let obj = summary[key];
                    let options = obj && obj.hasOwnProperty("options") && Array.isArray(obj.options) ? [...obj.options] : null;
                    let discount = {
                        title: obj.title,
                        id: obj.id,
                        non_standard_discounts: obj.non_standard_discounts,
                        options: options,
                        value: obj.discount,
                        edit: false,
                        image: obj.image,
                        is_image_visible: obj.is_image_visible,
                    }
                    discounts.push(discount)
                }
            }

            this.discounts = discounts;
        },
        computed: {
            getTotalDiscount() {
                return this.discounts.reduce((acc, el) => {
                    if (el.value === null || isNaN(el.value)) el.value = 0;
                    acc += parseFloat(el.value);
                    if (isNaN(acc)) return 0;
                    return acc;
                }, 0);
            },
            filteredOptions() {
              return this.options.filter((option) => {
                return this.translateOption(option.id[0], option.code).toLowerCase().includes(this.searchOptionFilterValue.toLowerCase());
              })
          },

            isOptionSelected() {
              return (this.fresh.id || this.fresh.id === 0);
            }
        }
    }
</script>
